/**
 * <StudentAssessmentsSkeleton> — la forme de « Mes contrôles » pendant son premier chargement.
 *
 * L'en-tête reste : c'est la liste qui attend. La carte-liste et trois lignes de contrôle
 * (`<SchoolAssessmentRowSkeleton>`), puis « Ajouter un contrôle », qui ne dépend d'aucune donnée.
 */
import React from "react"

import { CardList, CardListLinkRow } from "../../molecules/CardList"
import { SchoolAssessmentRowSkeleton } from "../../molecules/SchoolAssessmentRow/SchoolAssessmentRowSkeleton"

export function StudentAssessmentsSkeleton() {
    return (
        <CardList>
            <SchoolAssessmentRowSkeleton />
            <SchoolAssessmentRowSkeleton />
            <SchoolAssessmentRowSkeleton />
            <CardListLinkRow label="Ajouter un contrôle" iconName="plus" />
        </CardList>
    )
}
